"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const values = [{
  title: "Collaborative",
  description: "We don't just deliver solutions from on high; we co-design them with your team. By working side-by-side with your faculty and staff, we ensure that every strategy fits your unique culture, context, and capabilities."
}, {
  title: "Mission-Aligned",
  description: "We understand that higher education is more than a business—it’s a calling. We prioritize your institutional mission and student success above all else, ensuring that financial sustainability never comes at the cost of your soul."
}, {
  title: "Pragmatic",
  description: "We avoid academic jargon and theoretical fluff. Our strategies are actionable, realistic, and designed for immediate impact. We focus on what actually works in the complex reality of higher education administration."
}, {
  title: "Specialized",
  description: "We focus exclusively on lifelong learning in higher education. Unlike generalist firms that apply cookie-cutter corporate models, we know the specific landscape, challenges, and opportunities of the academic world."
}, {
  title: "Empowering",
  description: "Our ultimate goal is to build your internal capacity, not your dependency on us. We measure our success by how well you can sustain and grow your lifelong learning ecosystem long after our engagement ends."
}];
export default function OurValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-values" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-[var(--chart-2)]/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-[var(--primary)]/10 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <div ref={ref} className={cn("transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <div className="mb-16 text-center">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 tracking-tight">
              Our Core Values
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Rooted in sophisticated pragmatism, our philosophy guides every
              partnership. We believe in building capability, not dependency.
            </p>
          </div>

          <div className="bg-card/50 backdrop-blur-sm border border-border/50 rounded-xl p-6 md:p-10 shadow-2xl">
            <Accordion type="single" collapsible className="w-full">
              {values.map((value, i) => <AccordionItem key={i} value={`item-${i}`} className="border-border/60 last:border-0" data-index={i}>
                  <AccordionTrigger className="text-xl md:text-2xl font-serif font-medium py-6 hover:text-[var(--chart-2)] transition-colors [&_svg]:text-[var(--chart-2)] [&_svg]:size-6 [&_svg]:stroke-[3px]">
                    {value.title}
                  </AccordionTrigger>
                  <AccordionContent className="text-base md:text-lg text-muted-foreground leading-relaxed pb-6 max-w-3xl">
                    {value.description}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}